<div class="balance-history-dialog">
  <div class="balance-history-content">
    @if (loading) {
      <div class="flex items-center justify-center py-8">
        <div class="flex items-center space-x-2">
          <i class="pi pi-spin pi-spinner text-primary-500"></i>
          <span class="text-neutral-600 dark:text-neutral-400">{{
            'balanceHistory.loading' | transloco
          }}</span>
        </div>
      </div>
    } @else if (transactions.length === 0) {
      <div class="flex flex-col items-center justify-center py-8 text-center">
        <i class="pi pi-inbox text-4xl text-neutral-400 dark:text-neutral-500 mb-3"></i>
        <h3 class="text-lg font-medium text-neutral-700 dark:text-neutral-300 mb-2">
          {{ 'balanceHistory.emptyState.title' | transloco }}
        </h3>
        <p class="text-neutral-500 dark:text-neutral-400">
          {{ 'balanceHistory.emptyState.description' | transloco }}
        </p>
      </div>
    } @else {
      <div class="overflow-hidden rounded-lg border border-neutral-200 dark:border-neutral-700">
        <p-table
          [value]="transactions"
          [loading]="loading"
          styleClass="p-datatable-sm"
          [scrollable]="true"
          scrollHeight="90vh"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="text-start">{{ 'balanceHistory.table.date' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.description' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.balanceChange' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.currentBalance' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.tokensUsed' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.tokenCost' | transloco }}</th>
              <th class="text-start">{{ 'balanceHistory.table.referenceType' | transloco }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-transaction>
            <tr class="hover:bg-neutral-50 dark:hover:bg-neutral-800/50">
              <td class="text-sm">
                {{ formatDate(transaction.created_at) }}
              </td>
              <td class="text-sm max-w-xs truncate" [title]="transaction.description">
                {{ transaction.description }}
              </td>
              <td class="text-start">
                <p-tag
                  [value]="formatBalance(transaction.balance_change)"
                  [severity]="getSeverity(transaction.balance_change)"
                  [rounded]="true"
                >
                </p-tag>
              </td>
              <td class="text-start text-sm font-medium">
                {{ formatBalance(transaction.current_balance) }}
              </td>
              <td class="text-start text-sm">
                {{ transaction.tokens_used | number }}
              </td>
              <td class="text-start text-sm">
                {{ formatTokenCost(transaction.token_cost) }}
              </td>
              <td class="text-sm">
                <p-tag [value]="transaction.reference_type" severity="info" [rounded]="true">
                </p-tag>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center py-8 text-neutral-500 dark:text-neutral-400">
                {{ 'balanceHistory.table.noTransactions' | transloco }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</div>
